module.exports = __webpack_public_path__ + "static/media/exportar_inscripciones.b2cf1d93.png";